module.exports = __webpack_public_path__ + "img/theme_topmenu.7f6e4eb4.svg";